import {
  IRequirementResponse,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { RequirementAdditionalData } from "../types";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { getPayerSharedFileRequirementIsUploadAvailable } from "../modules/SharedFile/configs/helpers/getPayerSharedFileRequirementIsUploadAvailable";
import { InsuranceCoverageMonitor } from "../../../services/api/insurance/monitor/types";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorIsInstructionsModalAvailable = (
  requirement: IRequirementResponse,
  dataSource: RequirementAdditionalData
) => {
  if (requirement.requirementType === RequirementType.SharedFile) {
    const sharedFile = dataSource as ISharedFileRequestResponse;

    if (
      selectorIsSharedFileNotNoneContext(sharedFile.contextType) &&
      getPayerSharedFileRequirementIsUploadAvailable(requirement, sharedFile)
    ) {
      return true;
    }
  }

  if (requirement.requirementType === RequirementType.InsuranceCoverage) {
    const insuranceCoverageMonitor = dataSource as InsuranceCoverageMonitor;

    if (["Pending", "Monitoring"].includes(insuranceCoverageMonitor.status)) {
      return true;
    }
  }

  if (requirement.requirementType === RequirementType.IdentityVerification) {
    const identityVerification =
      dataSource as IIdentityVerificationRequestResponse;

    if (
      identityVerification.status === IdentityVerificationRequestStatus.Pending
    ) {
      return true;
    }
  }

  return false;
};
